import React from "react";

import "./_favorites_apps.scss";
import PopupFav, { popupFavs } from "./PopupFav";

function FavoritesApps(props) {
	const textColor = (props.config === undefined) ? null : props.config[1].value;
	const backgroundColor = (props.config === undefined) ? null : props.config[0].value;
	const shadowColor = (props.config === undefined) ? null : props.config[2].value;
	const textLinksColor = (props.config === undefined) ? null : props.config[3].value;

	return (
		<div
			style={{ color: textColor, textShadow: "0 0 3px " + shadowColor }}
			className="btn-favorites"
			onMouseEnter={() => popupFavs("40px", "showFavoritesApps")}
			onMouseLeave={() => popupFavs("30px", "hiddenFavoritesApps")}
		>
			{(props.lang === "es") ? "Favoritos" : "Favorites"}
			<PopupFav favorites={props.favorites} background={backgroundColor} shadow={shadowColor} text={textLinksColor} />
		</div>
	);
}

export default FavoritesApps;
